<template>
  <div class="new-data-type-modal">
    <div class="modal-backdrop"></div>
    <div class="modal-fullscreen new-data-type workflow-model-scroll">
      <div class="header" v-show="!loading">
        <div class="modal-btn" @click="onPullLeftButtonClick()">
          <img
            v-show="isCustomTypesVisible || isSQLTypesVisible"
            src="../assets/img/arrow-left.svg"
            style="width: 24px"
          />
        </div>
        <div @click="close" class="boostrap-close-btn">
          <b-icon icon="x-lg" font-scale="1.2"></b-icon>
        </div>
      </div>
      <div class="modal task">
        <div
          v-if="
            !isCustomTypesVisible && !editTable && !isTypeOfDatabasesVisible
          "
          class="full-height"
        >
          <h1 class="modal-header">
            Welche Art von Daten möchten Sie verwalten?
          </h1>
          <form id="form" @submit.prevent="beforeSelect">
            <div class="database-form-wrap">
              <input
                placeholder="Geben Sie einen Namen für den neuen Inhalt ein."
                v-model="contentType"
                pattern="^[a-zA-Z\d\-]*$"
                title="Bitte benutze nur Buchstaben (a-Z), Zahlen (0-9) und Bindestriche (-) in diesem Textfeld."
                :class="{
                  alert: isTableNameErrorVisible || tableNameAlreadyExists,
                }"
              />
              <div
                class="icon-container"
                v-b-tooltip.hover
                title="Nicht veränderbare Datenbank. Inhalte dauerhaft speichern, ohne dass Veränderungen möglich sind."
              >
                <label name="required">
                  <input type="checkbox" v-model="isAddOnly" />
                  <img src="../assets/img/lock-locked.svg" v-show="isAddOnly" />
                  <img src="../assets/img/lock-open.svg" v-show="!isAddOnly" />
                </label>
              </div>

              <input type="submit" ref="submit-btn" style="display: none" />
            </div>
          </form>
          <div class="group-wrapper">
            <div
              v-for="p in dataTypes"
              :key="p.id"
              class="item-wrapper"
              :class="[
                p.selected ? 'active' : '',
                !databasesAllowedToBeCreated.includes(p.name)
                  ? 'cursor-disable'
                  : '',
              ]"
              @click="submitForm(!tableNameAlreadyExists && p)"
            >
              <div class="img-wrapper">
                <img v-bind:src="getImgUrl(p.img)" class="icon" />
              </div>
              <h2>{{ p.label }}</h2>
              <div class="description">
                {{ p.description }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="isCustomTypesVisible || editTable">
          <h1 class="modal-header">
            Welche Attribute besitzt ein(e) "{{ contentType }}"?
          </h1>
          <div v-if="!customTypeElements.length" class="excel-file-wrapper">
            <span
              @click="$refs.hiddenFileInput.click()"
              class="excel-file-input-text"
              >Klicke hier, um die Attribute von "{{ contentType }}" aus einer
              Excel-/CSV-Datei zu importieren,</span
            >
            oder klicke unten auf den "+"-Knopf, um die Attribute selbst zu
            definieren.
            <input
              @change="saveExcelFileToDatabase($event)"
              ref="hiddenFileInput"
              type="file"
              accept=".xls, .xlsx, .csv"
              hidden
            />
          </div>
          <FormBuilder
            v-if="!loading"
            :elements="customTypeElements"
            :isCreateCustomDB="true"
            :structure="layout"
            :isFullWidth="fullWidth"
            :isEditable="true"
            :isContentEditable="true"
            :selectedDatabase="selectedDataType"
            :databaseMeta="databaseMeta"
            @saveElements="saveElements"
            @saveStructure="saveLayout"
            @onSheetFileSelect="saveExcelFileToDatabase($event, true)"
          />
          <div class="footer" v-if="customTypeElements.length > 0">
            <button
              v-if="!editTable"
              @click="
                createNewTable(
                  contentType,
                  isSheetDatabaseType ? 'sheet' : 'custom'
                )
              "
            >
              Erstellen
            </button>
            <button v-else @click="updateSchema()">Übernehmen</button>
          </div>
        </div>
        <div v-if="isSQLTypesVisible && !connectToDatabase">
          <h1>Verbindung zu PostgreSQL Herstellen</h1>
          <input
            type="text"
            placeholder="User"
            v-model="sqlConnection.username"
          />
          <input
            type="text"
            placeholder="Database Name"
            v-model="sqlConnection.dbname"
          />
          <input
            type="password"
            placeholder="Password"
            v-model="sqlConnection.password"
          />
          <input
            type="text"
            placeholder="Endpoint"
            v-model="sqlConnection.endpoint"
          />
          <div class="error" v-if="error">
            Fehler bei der Verbindung. Bitte kontrollieren Sie Ihre Angaben.
          </div>
          <div class="footer">
            <button @click="createConnection()">Verbinden</button>
          </div>
        </div>
        <div
          class="sql-modal"
          v-if="tableSelectionOfDatabase && !connectToDatabase"
        >
          <h1>Wähle die Tabelle aus, die du Anzeigen möchtest</h1>
          <ul name="table-list" id="tables-list" class="table-list">
            <li
              v-for="(table, i) in databaseTables"
              :key="i"
              :class="{ active: i == selectedTableIndex }"
              @click="selectTablesIndex(table, i)"
            >
              {{ table }}
            </li>
          </ul>
          <div class="error" v-if="error">
            Erstellungsfehler. Bitte kontrollieren Sie Ihre Angaben.
          </div>
          <div class="footer">
            <button @click="fetchTableColumns()">Datenbank einbinden</button>
          </div>
        </div>
        <div
          v-if="keySelectionOfDatabase && !connectToDatabase"
          class="full-height"
        >
          <h1>Wähle die Tabelle aus, die du Anzeigen möchtest</h1>
          <div class="sql-cdls-form">
            <form
              id="form"
              @submit.prevent="createNewTable(contentType, 'external database')"
            >
              <div class="input-group">
                <label>Id</label>
                {{ sqlCdls.id }}
                <select v-model="sqlCdls.id" required disabled>
                  <option
                    v-for="key in keySelectionOptions"
                    :key="key.name"
                    :value="key.name"
                    v-show="key.pk"
                    name="created"
                  >
                    {{ key.label }}
                  </option>
                </select>
              </div>
              <div class="input-group">
                <label>Created</label>
                <select v-model="sqlCdls.created">
                  <option
                    v-for="key in keySelectionOptions"
                    :key="key.name"
                    :value="key.name"
                    v-show="!key.pk"
                    name="created"
                  >
                    {{ key.label }}
                  </option>
                </select>
              </div>
              <div class="input-group">
                <label>Updated</label>
                <select v-model="sqlCdls.updated">
                  <option
                    v-for="key in keySelectionOptions"
                    :key="key.name"
                    :value="key.name"
                    v-show="!key.pk"
                    name="updated"
                  >
                    {{ key.label }}
                  </option>
                </select>
              </div>
              <div class="input-group">
                <label>Owner</label>
                <select v-model="sqlCdls.owner">
                  <option
                    v-for="key in keySelectionOptions"
                    :key="key.name"
                    :value="key.name"
                    v-show="!key.pk"
                    name="owner"
                  >
                    {{ key.label }}
                  </option>
                </select>
              </div>
              <div class="footer">
                <button type="submit">Datenbank einbinden</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="loading" v-if="loading || connectToDatabase">
        <div class="progress-icon-wrapper">
          <p>
            {{ getLoadingTitle }}
          </p>
          <!-- <p v-if="connectToDatabase">Please wait while connection is Being created</p> -->
          <div class="progress-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormBuilder from './widgets/FormBuilderV2.vue';
import { updateTableSchema } from '../services/userTable.js';
import {
  getTableColumns,
  createDatabaseTable,
} from '../services/customdb.service.js';

export default {
  name: 'NewDataType',
  data() {
    return {
      title: 'Art des neuen Inhalts',
      contentType: null,
      loading: false,
      isTableNameErrorVisible: false,
      dataTypes: [
        {
          id: 0,
          name: 'loadprofile',
          label: 'Zeitreihen',
          description: 'Metrik, Verbrauch, Preis-Entwicklung...',
          img: './chart.svg',
          selected: false,
        },
        {
          id: 1,
          name: 'document',
          label: 'Dokumente',
          description: 'Rechnung, Angebot, Lieferschein, Gutschrift...',
          img: './document.svg',
          selected: false,
        },
        {
          id: 2,
          name: 'person',
          label: 'Personen',
          description: 'Mitarbeiter, Kontakt, Kunde, Ansprechpartner...',
          img: './person.svg',
          selected: false,
        },
        {
          id: 3,
          name: 'organisation',
          label: 'Organisationen',
          description: 'Unternehmen, Kunde, Lieferant, Partner...',
          img: './building.svg',
          selected: false,
        },
        {
          id: 4,
          name: 'task',
          label: 'Aufgaben',
          description: 'Tägliche ToDos, Projektaufgaben, Followups...',
          img: './todos.svg',
          selected: false,
        },
        {
          id: 5,
          name: 'media',
          label: 'Medien',
          description: 'Videos, Bilder, Logos, Tonaufnahmen, ...',
          img: './media.svg',
          selected: false,
        },
        {
          id: 6,
          name: 'custom',
          label: 'Benutzerdefiniert',
          description:
            'Definieren Sie selber welche Attribute der neue Inhalt haben soll...',
          img: './setting.svg',
          selected: false,
        },
        {
          id: 7,
          name: 'external database',
          label: 'Externe Daten',
          description: 'Verwalten Sie Daten aus externe Datenbanken.',
          img: './database-link.svg',
          selected: false,
        },
        {
          id: 8,
          name: 'sheet',
          label: 'Sheet',
          description:
            'Die Sheet Datenbank ist perfekt geeignet um grosse Datensätze mit einer Excel Struktur zu speichern.',
          img: './database-link.svg',
          selected: false,
        },
      ],
      isCustomTypesVisible: false,
      isSQLTypesVisible: false,
      customTypeElements: [],
      selectedDataType: null,
      databasesAllowedToBeCreated: [
        'loadprofile',
        'custom',
        'external database',
        'sheet',
      ],
      sheetDatabaseDefaultElements: [
        {
          attributes: {
            required: true,
          },
          options: [],
          type: 'text',
          label: 'Dateiname',
          name: 'filename',
          value: null,
          highlight: true,
        },
        {
          attributes: {
            required: true,
          },
          options: [],
          type: 'text',
          label: 'Anzahl Datensätze',
          name: 'rowcount',
          value: null,
          highlight: true,
        },
        {
          attributes: { required: true },
          options: [],
          type: 'sheet',
          label: 'sheet',
          name: 'data',
          value: null,
          highlight: true,
        },
      ],
      layout: {
        tabs: [
          {
            id: 0,
            rows: [
              {
                id: 0,
                cols: [
                  {
                    id: 0,
                  },
                ],
              },
            ],
          },
        ],
      },
      fullWidth: false,
      connectToDatabase: false,
      tableSelectionOfDatabase: false,
      keySelectionOfDatabase: false,
      keySelectionOptions: [],
      sqlCdls: {
        id: '',
        created: '',
        updated: '',
        owner: '',
      },
      sqlConnection: {
        username: '',
        password: '',
        dbname: '',
        endpoint: '',
      },
      databaseTables: [],
      tableName: null,
      databaseType: null,
      selectedTableIndex: 0,
      error: false,
      isTypeOfDatabasesVisible: false,
      isAddOnly: false,
    };
  },
  props: {
    tableList: Array,
    editTable: Boolean,
    databaseMeta: Object,
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    onPullLeftButtonClick() {
      this.isCustomTypesVisible = false;
      this.isSQLTypesVisible = false;
      if (this.isTypeOfDatabasesVisible) this.isTypeOfDatabasesVisible = false;
    },
    close() {
      this.$emit('close');
    },
    getImgUrl: function (img) {
      if (img) {
        var images = require.context('../assets/img/', false);
        return images(img);
      } else return '';
    },
    submitForm: function (p) {
      if (this.databasesAllowedToBeCreated.includes(p.name)) {
        this.selectedDataType = p;
        this.isSheetDatabaseType
          ? (this.customTypeElements = this.sheetDatabaseDefaultElements)
          : (this.customTypeElements = []);
        this.$refs['submit-btn'].click();
      }
    },
    beforeSelect: function () {
      // Only custom & loadprofile is supported at the moment
      if (
        !this.databasesAllowedToBeCreated.includes(this.selectedDataType.name)
      )
        return null;
      if (this.hasTableName) this.select(this.selectedDataType);
      else this.showTableNameError();
    },
    select: function (p) {
      this.dataTypes.forEach((p) => {
        p.selected = false;
      });
      p.selected = true;
      if (p.name == 'custom' || p.name == 'sheet') {
        this.databaseType = 'DynamoDB';
        this.showCustomType();
      } else if (p.name === 'external database') {
        this.databaseType = 'PostgreSQL';
        this.isSQLTypesVisible = true;
        this.isTypeOfDatabasesVisible = true;
      } else {
        this.databaseType = 'DynamoDB';
        this.createNewTable(this.contentType, p.name);
      }
    },

    formatTablename: function (str) {
      return str
        .replace(/ /g, '-')
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue');
    },

    showTableNameError() {
      this.isTableNameErrorVisible = true;

      setTimeout(() => {
        this.isTableNameErrorVisible = false;
      }, 3000);
    },
    showCustomType: function () {
      this.isCustomTypesVisible = true;
    },
    async createNewTable(tableName, tableType) {
      const formData = new FormData();
      formData.append('caption', this.contentType);
      formData.append('add_only', this.isAddOnly);
      formData.append(
        'tablename',
        this.databaseType == 'PostgreSQL'
          ? this.formatTablename(this.contentType)
          : this.user.username + '_' + this.formatTablename(tableName)
      );
      formData.append('tabletype', tableType);
      formData.append('database_type', this.databaseType);
      formData.append('schema', JSON.stringify(this.customTypeElements));
      formData.append('layout', JSON.stringify(this.layout));
      formData.append('icon', null);
      if (tableType === 'external database') {
        formData.append(
          'credentials',
          JSON.stringify({ ...this.sqlConnection, tablename: this.tableName })
        );
        formData.append('sql_cdls', JSON.stringify(this.sqlCdls));
      }

      this.title = 'Datenbank wird erstellt...';
      this.loading = true;
      try {
        const response = await createDatabaseTable(formData);
        this.title = 'Art des neuen Inhalts';
        this.$emit('close', JSON.parse(response.data));
      } catch (e) {
        this.showToaster(e.message, 'Error !', 'denger');
      }
      this.loading = false;
    },
    createConnection() {
      this.connectToDatabase = true;
      const url = `${process.env.VUE_APP_DATA_API}/user-tables/connection/status`;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      let formData = new FormData();
      formData.append('user', this.sqlConnection.username);
      formData.append('dbname', this.sqlConnection.dbname);
      formData.append('password', this.sqlConnection.password);
      formData.append('host', this.sqlConnection.endpoint);

      fetch(url, { body: formData, headers: myHeaders, method: 'post' })
        .then((response) => response.json())
        .then((table) => {
          if (table.status === 'failed') {
            this.error = true;
            this.tableSelectionOfDatabase = false;
            this.connectToDatabase = false;
          } else {
            this.error = false;
            this.tableSelectionOfDatabase = true;
            this.databaseTables = table.table_names;
            this.connectToDatabase = false;
            this.isSQLTypesVisible = false;
          }
        });
    },
    async fetchTableColumns() {
      this.loading = true;
      try {
        const response = await getTableColumns({
          credentials: {
            ...this.sqlConnection,
            tablename: this.tableName,
          },
        });
        if (response.status === 'failed') {
          this.error = true;
        } else {
          this.error = false;
          this.keySelectionOptions = response.data.columns;
          this.sqlCdls.id = response.data.columns.find(
            (column) => column.pk
          )?.name;
          this.tableSelectionOfDatabase = false;
          this.keySelectionOfDatabase = true;
        }
      } catch (e) {
        this.showToaster(e.message, 'Error !', 'danger');
      }
      this.loading = false;
    },

    async updateSchema() {
      const formData = new FormData();

      formData.append('value', JSON.stringify(this.customTypeElements));

      this.title = 'Datenbank wird bearbeitet...';
      this.loading = true;

      await updateTableSchema(
        this.user,
        this.databaseMeta.name,
        formData,
        'schema'
      );

      this.loading = false;
      this.$emit('close');
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    saveElements: function (elements) {
      this.customTypeElements = elements;
    },
    saveLayout: function (layout) {
      this.layout = layout;
    },
    selectTablesIndex(table, index) {
      this.tableName = table;
      this.selectedTableIndex = index;
    },
    async saveExcelFileToDatabase(event, isSheetTypeUpload = false) {
      try {
        this.loading = true;
        const url = `${process.env.VUE_APP_FILE_PARSER_API}/create-schema`;

        const myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );
        const formData = new FormData();
        formData.append(
          'database',
          this.user.username + '_' + this.formatTablename(this.contentType)
        );
        formData.append(
          'file',
          isSheetTypeUpload ? event : event.target.files[0]
        );
        const excelUploadResponse = await fetch(url, {
          headers: myHeaders,
          body: formData,
          method: 'POST',
        });
        if (excelUploadResponse.status == 200) {
          this.$bvToast.toast('Datei erfolgreich analysiert', {
            title: 'Erfolgreich', //success
            variant: 'success',
            solid: true,
          });
          const excelUploadJsonResponse = await excelUploadResponse.json();
          if (isSheetTypeUpload) {
            this.customTypeElements[0].value = event.name;
            this.customTypeElements[1].value = excelUploadJsonResponse.length;
            this.customTypeElements[2].columns = excelUploadJsonResponse;
          } else {
            this.customTypeElements = excelUploadJsonResponse;
          }
          this.loading = false;
        } else if (excelUploadResponse.status == 404)
          throw new Error('Resource not found');
        else if (excelUploadResponse.status == 401) {
          localStorage.clear();
          this.$router.push({
            name: 'auth',
            params: { message: 'Sitzung abgelaufen' },
          });
        } else throw new Error('CORS');
      } catch {
        this.$bvToast.toast('Fehler beim Parsen der Datei', {
          title: 'Fehlerhaft', //error
          variant: 'danger',
          solid: true,
        });
        this.loading = false;
      }
    },
  },
  created() {
    if (this.editTable) {
      this.contentType = this.nameWithoutPrefix(this.databaseMeta.name);
      this.customTypeElements = JSON.parse(this.databaseMeta.schema);

      if (this.editTable) this.layout = JSON.parse(this.databaseMeta.layout);
    }
  },
  computed: {
    ...mapGetters({ user: 'getUser' }),
    hasTableName() {
      return this.contentType != null && this.contentType != '';
    },
    tableNameAlreadyExists() {
      return this.tableList.includes(
        this.user.username + '_' + this.contentType
      );
    },
    isModalOpen() {
      return (
        !this.isCustomTypesVisible &&
        !this.editTable &&
        !this.isSQLTypesVisible &&
        !this.tableSelectionOfDatabase
      );
    },
    isSheetDatabaseType() {
      return this.selectedDataType && this.selectedDataType.name === 'sheet';
    },
    getLoadingTitle() {
      return this.loading
        ? this.isSheetDatabaseType
          ? 'Datenschema wird aus Datei gelesen...'
          : 'Datenbank wird erstellt...'
        : 'Verbindung wird hergestellt...';
    },
  },
  components: {
    FormBuilder,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.modal-fullscreen {
  position: fixed;
  background: #ffffff;
  display: block;
  text-align: center;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
  width: 70%;
  height: 98%;
  top: 1%;
  z-index: 15;
}

.modal {
  z-index: unset;
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 80%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  top: 0;
  position: absolute;
  left: 10%;
  top: 1%;
  height: 98%;
}

.sql-modal {
  height: 100%;
}

.sql-modal .table-list {
  max-height: calc(100% - 230px);
  overflow: scroll;
}

h1 {
  padding-top: 60px;
  color: #313745;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.12px;
  line-height: 41px;
  text-align: center;
  display: block;
  width: 100%;
  margin: 0 auto 40px;
  border: 0;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: relative;
  -webkit-font-smoothing: antialiased;
  text-transform: none;
}

@media (max-width: 1199px) {
  .modal.task .modal-header {
    font-size: 25px;
  }
}

.modal > h4 {
  color: rgba(85, 93, 109, 0.4);
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.new-data-type .loading {
  width: 96%;
  height: 90%;
  background-color: #ffff;
  position: absolute;
  top: 50px;
}

.progress-icon-wrapper {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  height: fit-content;
}

.progress-icon-wrapper .progress-icon {
  position: relative;
  width: 70px;
  height: 70px;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.progress-icon-wrapper p {
  margin-bottom: 30px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.database-form-wrap {
  width: 60%;
  margin: 0 auto 20px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.database-form-wrap .icon-container img {
  height: 26px;
  cursor: pointer;
  transition: all 500ms ease-in-out;
  object-fit: contain;
}

.database-form-wrap .icon-container input {
  opacity: 0;
  width: 0;
  height: 0;
}
.new-data-type input {
  float: none;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 15px 20px 15px 20px;
  height: 51px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 18px;
  font-weight: 400;
  line-height: 19px;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 93%;
  position: relative;
}

.new-data-type textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

::placeholder {
  color: #a5abb3;
  opacity: 1;
}

.new-data-type button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

.new-data-type .pull-right {
  float: right;
  margin: 15px 15px 0px 0px;
}

.pull-right .btn-close {
  background-image: url(/img/modal-sprite.67649c98.png);
  background-size: 1293px 1277px;
  background-position: -1278px -577px;
  cursor: pointer;
  border-radius: unset;
}

.new-data-type .item {
  height: 175px;
}
.full-height {
  height: 100%;
}
.new-data-type .group-wrapper {
  margin: 0 auto 30px;
  text-align: center;
  margin-top: 5px;
  height: calc(100% - 270px);
  width: 100%;
  overflow: auto;
}

.new-data-type .item-wrapper:hover .img-wrapper {
  filter: none;
}

.new-data-type .item-wrapper.active .img-wrapper {
  filter: none;
}

.new-data-type .item-wrapper.active {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
}

.new-data-type .item-wrapper:hover {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
}

.new-data-type .item-wrapper .img-wrapper {
  filter: grayscale(82%) hue-rotate(246deg) opacity(50%);
}

.new-data-type .item-wrapper {
  display: inline-block;
  width: 200px;
  height: 263px;
  margin: 10px;
  opacity: 1;
  cursor: pointer;
  text-align: -webkit-match-parent;
  box-shadow: none;
  overflow: hidden;
}

.new-data-type .img-wrapper {
  width: 100%;
  height: 160px;
}

.new-data-type input {
  display: initial;
}

.new-data-type .icon {
  position: absolute;
  width: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: none;
  background-color: #fff;
  padding: 0 6px 0 6px;
  max-height: 103px;
}

.new-data-type .item-wrapper h2 {
  color: #434c5e;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.16px;
  line-height: 19px;
}

.new-data-type .footer {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
}

.new-data-type .footer > button {
  display: block;
  width: 180px;
  height: 44px;
  margin: 30px auto 80px;
  background: #fff;
  border: solid 2px #191f24;
  border-radius: 100px;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  color: #191f24;
  letter-spacing: 1px;
  -webkit-transition: background 0.2s ease;
  -o-transition: background 0.2s ease;
  transition: background 0.2s ease;
  cursor: pointer;
}

.new-data-type .footer > button:hover {
  background: #fb3467;
  color: #fff;
  border: solid 2px #fb3467;
}

.new-data-type .item-wrapper .description {
  font-family: 'SF UI Text', -apple-system, system-ui, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  text-transform: none;
  color: #7b8496;
  -webkit-font-smoothing: antialiased;
  max-width: 100%;
  margin: 0px 13px 0px 13px;
  opacity: 0;
  transform: translateY(15px);
  transition: 0.2s ease;
}

.new-data-type .item-wrapper:hover .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.form-container {
  min-height: 350px;
}

.modal-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;
}

.modal-btn:hover {
  zoom: 1.05;
}

.modal-btn img {
  width: 23px;
}

.pull-left {
  float: left;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
}
.header * {
  box-sizing: border-box;
}

input.alert {
  background: #ff050578;
  animation: shake 0.2s ease-in-out 0s 2;
  box-shadow: 0 0 0.5em red;
}

input.alert::-webkit-input-placeholder,
input.alert:-ms-input-placeholder,
input.alert::placeholder {
  color: rgba(0, 0, 0, 0.651);
}

@keyframes shake {
  0% {
    margin-left: 0rem;
  }
  25% {
    margin-left: 0.5rem;
  }
  75% {
    margin-left: -0.5rem;
  }
  100% {
    margin-left: 0rem;
  }
}

.new-data-type .item-wrapper.cursor-disable .img-wrapper:hover {
  filter: grayscale(82%) hue-rotate(246deg) opacity(50%);
}

.new-data-type .item-wrapper.cursor-disable {
  cursor: not-allowed;
}

.new-data-type .item-wrapper.cursor-disable img {
  cursor: not-allowed;
}

.table-list {
  margin: 0 auto;
  padding: 0;
  max-width: 350px;
  list-style: none;
  border-radius: 4px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
  text-align: left;
}

.table-list li:hover,
.table-list li.active {
  background: #eee;
}
.table-list li {
  padding: 10px 10px;
  cursor: pointer;
  transition: all 400ms ease-in-out;
  font-weight: 600;
}
.error {
  text-align: center;
  font-weight: bold;
  color: red;
}

.workflow-model-scroll .modal.task,
.workflow-model-scroll .modal.task .form-container {
  overflow: unset !important;
}
.modal .excel-file-wrapper {
  color: rgba(55, 53, 47, 0.5);
  font-size: 14px;
  padding-bottom: 20px;
}
.excel-file-wrapper .excel-file-input-text {
  text-decoration: underline;
  cursor: pointer;
}

.boostrap-close-btn {
  cursor: pointer;
  display: inline-block;
}
.boostrap-close-btn svg {
  position: relative;
  top: 3px;
}
::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
.new-data-type-modal select {
  width: 100%;
  padding: 15px;
  background: white;
  margin-bottom: 20px;
  margin-left: 0 !important;
}

.new-data-type-modal .sql-cdls-form {
  overflow: auto;
  height: calc(100% - 160px);
}
</style>
